export const logAppError = (
  error: Error,
  info: { componentStack?: string | null | undefined },
) => {
  // Log to Sentry
};
